import React, { Component } from "react";

import "./style.css";

export default class PageContent extends Component {
  render() {
    return <div className="page-content-container">{this.props.children}</div>;
  }
}
